export default __webpack_public_path__ + "components/bike-park-header/static/background--5-342de1dfbf2780fc81fe090b8c76ba39.jpg";